// extracted by mini-css-extract-plugin
export default {"wrapper":"layout_wrapper__R6T+Y"};